import { Link, useParams } from 'react-router-dom';
import "../static/ContactAdminPage.css";
import Footer from '../components/common/Footer';

function ContactAdminPage() {
    const { courseId } = useParams();

    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text);
        alert('Copied to clipboard!');
    };

    return (
        <div className="support-wrapper">
            <div className="support-page">
                <div className="support-container">
                    <div className="support-header">
                        <div className="support-breadcrumb">
                            <Link to={`/course/${courseId}`} className="support-back-link">
                                <i className="fas fa-arrow-left"></i>
                                <span className="support-back-text">Back to Course</span>
                            </Link>
                        </div>
                        <div className="support-header-content">
                            <div className="support-header-icon">
                                <i className="fas fa-headset"></i>
                            </div>
                            <h1 className="support-title">Enrollment Support</h1>
                            <p className="support-subtitle">
                                This course requires manual enrollment assistance. Our dedicated support team is here to help you through the process.
                            </p>
                        </div>
                    </div>

                    <div className="support-content">
                        <div className="support-section-header">
                            <h2 className="support-section-title">Contact Our Enrollment Team</h2>
                            <p className="support-section-subtitle">Choose your preferred contact method</p>
                        </div>

                        <div className="support-grid">
                            {/* Email Card */}
                            <div className="support-card support-email-card">
                                <div className="support-card-header">
                                    <div className="support-card-icon">
                                        <i className="fas fa-envelope-open-text"></i>
                                    </div>
                                    <h3 className="support-card-title">Email Support</h3>
                                </div>
                                <div className="support-card-body">
                                    <p className="support-card-description">Preferred method for enrollment requests</p>
                                    <div className="support-options">
                                        <div className="support-option">
                                            <div className="support-option-header">
                                                <span className="support-option-label">Primary</span>
                                                <button 
                                                    className="support-copy-btn"
                                                    onClick={() => copyToClipboard('hayducate@gmail.com')}
                                                    aria-label="Copy email address"
                                                >
                                                    <i className="far fa-copy"></i>
                                                </button>
                                            </div>
                                            <a 
                                                href="mailto:hayducate@gmail.com?subject=Enrollment Request&body=Hello, I would like to enroll in a course."
                                                className="support-action support-primary-action"
                                            >
                                                <i className="fas fa-paper-plane"></i>
                                                <span className="support-action-text">Send Email</span>
                                            </a>
                                            <p className="support-email-address">hayducate@gmail.com</p>
                                        </div>

                                        <div className="support-option">
                                            <div className="support-option-header">
                                                <span className="support-option-label">Secondary</span>
                                                <button 
                                                    className="support-copy-btn"
                                                    onClick={() => copyToClipboard('admin@hayducate.com')}
                                                    aria-label="Copy email address"
                                                >
                                                    <i className="far fa-copy"></i>
                                                </button>
                                            </div>
                                            <a 
                                                href="mailto:admin@hayducate.com?subject=Enrollment Request&body=Hello, I would like to enroll in a course."
                                                className="support-action support-secondary-action"
                                            >
                                                <i className="fas fa-envelope"></i>
                                                <span className="support-action-text">Send Email</span>
                                            </a>
                                            <p className="support-email-address">admin@hayducate.com</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Phone Card */}
                            <div className="support-card support-phone-card">
                                <div className="support-card-header">
                                    <div className="support-card-icon">
                                        <i className="fas fa-phone-volume"></i>
                                    </div>
                                    <h3 className="support-card-title">Phone Support</h3>
                                </div>
                                <div className="support-card-body">
                                    <p className="support-card-description">Speak with our enrollment specialists</p>
                                    <div className="support-option">
                                        <div className="support-option-header">
                                            <span className="support-option-label">Direct Line</span>
                                            <button 
                                                className="support-copy-btn"
                                                onClick={() => copyToClipboard('+254727880887')}
                                                aria-label="Copy phone number"
                                            >
                                                <i className="far fa-copy"></i>
                                            </button>
                                        </div>
                                        <div className="support-phone-display">
                                            <i className="fas fa-phone"></i>
                                            <span className="support-phone-number">+254727880887</span>
                                        </div>
                                        <div className="support-phone-actions">
                                            <a href="tel:+254727880887" className="support-action support-call-action">
                                                <i className="fas fa-phone-alt"></i>
                                                <span className="support-action-text">Call Now</span>
                                            </a>
                                            <a 
                                                href="https://wa.me/254727880887" 
                                                target="_blank" 
                                                rel="noopener noreferrer"
                                                className="support-action support-whatsapp-action"
                                            >
                                                <i className="fab fa-whatsapp"></i>
                                                <span className="support-action-text">WhatsApp</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Social Media Section */}
                        <div className="support-social-section">
                            <div className="support-social-header">
                                <h3 className="support-social-title">Connect With Us</h3>
                                <p className="support-social-subtitle">Follow us on social media for updates, tips, and more</p>
                            </div>
                            <div className="support-social-grid">
                                {/* LinkedIn */}
                                <a 
                                    href="https://linkedin.com/company/hayducate" 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="support-social-card support-social-linkedin"
                                >
                                    <div className="support-social-icon-wrapper">
                                        <i className="fab fa-linkedin-in"></i>
                                    </div>
                                    <div className="support-social-info">
                                        <h4 className="support-social-name">LinkedIn</h4>
                                        <p className="support-social-handle">@hayducate</p>
                                    </div>
                                    <i className="fas fa-arrow-right support-social-arrow"></i>
                                </a>

                                {/* YouTube */}
                                <a 
                                    href="https://youtube.com/@hayducate" 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="support-social-card support-social-youtube"
                                >
                                    <div className="support-social-icon-wrapper">
                                        <i className="fab fa-youtube"></i>
                                    </div>
                                    <div className="support-social-info">
                                        <h4 className="support-social-name">YouTube</h4>
                                        <p className="support-social-handle">@hayducate</p>
                                    </div>
                                    <i className="fas fa-arrow-right support-social-arrow"></i>
                                </a>

                                {/* TikTok */}
                                <a 
                                    href="https://tiktok.com/@hayducate" 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="support-social-card support-social-tiktok"
                                >
                                    <div className="support-social-icon-wrapper">
                                        <i className="fab fa-tiktok"></i>
                                    </div>
                                    <div className="support-social-info">
                                        <h4 className="support-social-name">TikTok</h4>
                                        <p className="support-social-handle">@hayducate</p>
                                    </div>
                                    <i className="fas fa-arrow-right support-social-arrow"></i>
                                </a>
                            </div>
                        </div>

                        {/* Thank You Message */}
                        <div className="support-thank-you">
                            <div className="support-thank-you-card">
                                <div className="support-thank-you-content">
                                    <div className="support-thank-you-icon">
                                        <i className="fas fa-graduation-cap"></i>
                                    </div>
                                    <div>
                                        <h3 className="support-thank-you-title">Thank You for Choosing Hayducate!</h3>
                                        <p className="support-thank-you-message">
                                            We're excited to have you learn with us. Hayducate is an inline platform dedicated to 
                                            providing quality education and personalized learning experiences. Our team is here to 
                                            ensure you get the support you need to succeed in your educational journey.
                                        </p>
                                    </div>
                                </div>
                                <div className="support-platform-features">
                                    <div className="support-feature">
                                        <i className="fas fa-bolt support-feature-icon"></i>
                                        <span className="support-feature-text">Inline Learning Platform</span>
                                    </div>
                                    <div className="support-feature">
                                        <i className="fas fa-users support-feature-icon"></i>
                                        <span className="support-feature-text">Personalized Support</span>
                                    </div>
                                    <div className="support-feature">
                                        <i className="fas fa-rocket support-feature-icon"></i>
                                        <span className="support-feature-text">Career Growth Focus</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default ContactAdminPage;